import React, { useState } from 'react';
import { Button, Card, Col, Row } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import MedHourTable from './MedHourTable.js';
import EditMedHourModal from './EditMedHourModal.js';
import CommonBreadCrumb from 'components/commonbreadcrumb/CommonBreadCrumb.js';
import paths from 'routes/paths.js';

const MedHour = () => {
    const [trigger, setTrigger] = useState(0);
    const [edittrigger, setEditTrigger] = useState(0);
    const [medhrval, setMedHrVal] = useState(null);
    const [showModal, setShowModal] = useState(false);

    const handleOpenAddModal = () => {
        setMedHrVal(null);
        setEditTrigger(0);
        setShowModal(true);
    };

    const callAnotherChildMethod = () => {
        setTrigger((prev) => prev + 1);
    };

    const callAnotherEditChildMethod = (editValue) => {
        setMedHrVal(editValue);
        setEditTrigger((prev) => prev + 1);
        setShowModal(true);
    };

    const breadcrumbItems = [
        { name: 'Dashboard', href: '/main', isActive: false },
        { name: 'Prescription-Hour', href: paths.medHour, isActive: true }
    ];

    return (
        <>
            <CommonBreadCrumb breadcrumbItems={breadcrumbItems} />
            <Row className="g-3 mt-1">
                <Col xs={12}>
                    <Card>
                        <Card.Header className="bg-body-tertiary py-2">
                            <h5 className="mb-0">Hour / HOA</h5>
                        </Card.Header>
                        <Card.Body>
                            <MedHourTable
                                trigger={trigger}
                                onCallEditParent={callAnotherEditChildMethod}
                                onOpenAddModal={handleOpenAddModal}
                            />
                        </Card.Body>
                    </Card>
                </Col>
            </Row>

            <EditMedHourModal
                show={showModal}
                onHide={() => setShowModal(false)}
                medhourvalue={medhrval}
                edittrigger={edittrigger}
                onCallParent={callAnotherChildMethod}
            />
        </>
    );
};

export default MedHour;

